/** Browser-side decoder for metadata staged in the wizard. */

function decodeText(bytes) {
  if(bytes.length>=2 && bytes[0]===0xFF && bytes[1]===0xFE) {
    return new TextDecoder('utf-16le').decode(bytes.subarray(2))
  }
  if(bytes.length>=2 && bytes[0]===0xFE && bytes[1]===0xFF) {
    return new TextDecoder('utf-16be').decode(bytes.subarray(2))
  }
  try{
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes)
  }catch(e) {
    let text = ''
    const chunk_size = 8192
    for(let offset=0; offset<bytes.length; offset+=chunk_size) {
      text += String.fromCharCode(...bytes.subarray(offset, offset + chunk_size))
    }
    return text
  }
}

function base64Bytes(value) {
  const binary = atob(value)
  const bytes = new Uint8Array(binary.length)
  for(let i=0; i<binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return bytes
}

/** Decodes a data URL or plain text without depending on Node's Buffer global. */
export function decodeUpload(value) {
  if(value==null) return null
  const input = String(value)
  const match = /^data:([^,]*),/.exec(input)
  if(!match) {
    const bytes = new TextEncoder().encode(input)
    return { bytes, text: input, name: '' }
  }

  let name = (/;name=([^;,]*)/.exec(match[1]) || [])[1] || ''
  try{ name = decodeURIComponent(name) }catch(e) { /* keep the original name */ }
  const payload = input.slice(match[0].length)
  let bytes
  try{
    bytes = /;base64/.test(match[1]) ? base64Bytes(payload) : new TextEncoder().encode(decodeURIComponent(payload))
  }catch(e) {
    return null
  }
  return { bytes, text: decodeText(bytes), name }
}

export { decodeText }
